import { create } from 'zustand';

import type {
  ToolPermission,
  ToolPermissionStoreActions,
  ToolPermissionStoreState,
} from '@/type';

const INIT_STATE: ToolPermissionStoreState = {
  permission: {
    labeling: {
      readable: true,
      updatable: false,
      acceptable: false,
    },
    labelingReview: {
      readable: true,
      updatable: false,
      acceptable: false,
    },
    preAnnotation: {
      acceptable: false,
    },
    aiAssist: {
      acceptable: false,
    },
  },
};

const useToolPermissionStore = create<
  ToolPermissionStoreState & ToolPermissionStoreActions
>((set, get) => {
  const setPermissionByType = <
    T extends keyof ToolPermission,
    K extends keyof ToolPermission[T],
  >(
    type: T,
    key: K,
    value: ToolPermission[T][K],
  ) => {
    set({
      permission: {
        ...get().permission,
        [type]: {
          ...get().permission[type],
          [key]: value,
        },
      },
    });
  };

  return {
    ...INIT_STATE,

    initPermission() {
      set({
        permission: INIT_STATE.permission,
      });
    },

    setPermission(permission) {
      set({ permission });
    },

    setLabelingPermission(labelingPermission) {
      get().setPermission({
        ...get().permission,
        labeling: labelingPermission,
      });
    },

    setLabelingPermissionByName(key, value) {
      setPermissionByType('labeling', key, value);
    },

    setLabelingReviewPermission(labelingReviewPermission) {
      get().setPermission({
        ...get().permission,
        labelingReview: labelingReviewPermission,
      });
    },

    setLabelingReviewPermissionByName(key, value) {
      setPermissionByType('labelingReview', key, value);
    },
  };
});

export default useToolPermissionStore;
